import OneSignal from 'onesignal-cordova-plugin'
import { platform } from '../device/platform'
import { processDeepLinkUrl } from '../deep-links'



type ForegroundHandler = (type: string, data?: Record<string, unknown>) => void
let _onForeground: ForegroundHandler | null = null
let _initialized = false

export function initOneSignal (): void {
  if (platform === 'web' || _initialized) return

  const appId = process.env.ONESIGNAL_APP_ID
  if (!appId) return

  OneSignal.initialize(appId)

  // Deshabilitar In-App Messages (modal "Habilite las notificaciones...")
  OneSignal.InAppMessages.setPaused(true)

  OneSignal.Notifications.addEventListener('foregroundWillDisplay', (event: any) => {
    const data = event.getNotification().additionalData as Record<string, unknown> | undefined
    if (data?.zips) {
      event.preventDefault()
      _onForeground?.('zips', data)
    }
  })

  OneSignal.Notifications.addEventListener('click', (event: any) => {
    const data = event.notification?.additionalData as Record<string, unknown> | undefined
    if (data?.app_url != null && typeof data.app_url === 'string') {
      processDeepLinkUrl(data.app_url)
    }
  })

  _initialized = true
}

export function requestOneSignalPermission (): void {
  if (platform === 'web' || !_initialized) return
  OneSignal.Notifications.requestPermission(true)
}

export function loginOneSignal (uid: string): void {
  if (platform === 'web' || !_initialized) return
  OneSignal.login(uid)
}

export function logoutOneSignal (): void {
  if (platform === 'web' || !_initialized) return
  OneSignal.logout()
}

export function setOneSignalTags (plan: number | string, wkspId: number | string): void {
  if (platform === 'web' || !_initialized) return
  OneSignal.User.addTags({
    plan: String(plan),
    id_escritorio: String(wkspId)
  })
}

export function onForegroundNotification (handler: ForegroundHandler): void {
  _onForeground = handler
}
